import React from "react";
import { Flex } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { Section } from "components/section";
import { Diptych } from "ui/diptych";
import { Button } from "ui/button";
import bodyFeatureImage1 from "../../../../public/assets/platform/identity-resolution/main-product-feature-1.png";
import bodyFeatureImage2 from "../../../../public/assets/platform/identity-resolution/main-product-feature-2.png";
import bodyFeatureImage3 from "../../../../public/assets/platform/identity-resolution/main-product-feature-3.png";

export function IdrProductFeatures() {
  return (
    <Section bg="white">
      <Flex flexDir="column" gap={{ base: "huge", md: "huger" }}>
        <Diptych
          size="lg"
          direction="right"
          chip={{ text: "Identity graph builder" }}
          titleAs="h2"
          title="Unify customer profiles with a visual rule builder"
          description="Build, test, and tune your own identity resolution rules without touching code. Make changes when you want to, roll them back if you need to."
          media={
            <FillImage
              src={bodyFeatureImage1}
              alt='Illustration showing an representation of the visual rule builder UI from the Hightouch application. The example shows a rule that will merge records when an "Anonymous ID" matches exactly, or when a "Name" matches exactly and a "Zip code" matches exactly, with the option to add more identifiers to continue building the rule.'
            />
          }
          actions={
            <Button hasRightChevron href="/docs/identity-resolution/overview#match-rule-creation" target="_blank">
              Learn more
            </Button>
          }
        />
        <Diptych
          size="lg"
          direction="left"
          chip={{ text: "Golden Record" }}
          titleAs="h2"
          title="Make perfect customer profiles"
          description="Choose which identifiers should “survive” on each customer record, while still retaining all the values in your data warehouse in case you want to change the logic later. Our Golden Record tool puts you in the driver’s seat, so you can create profiles that are actionable and trustworthy."
          media={
            <FillImage
              src={bodyFeatureImage3}
              alt="Illustration of Hightouch's Golden Record feature showing how multiple customer identifiers are consolidated. The interface displays a customer profile for Dennis Jones with source data on the left (multiple email addresses and phone numbers) being unified into a single Golden Record on the right. The Golden Record shows the preferred email, phone number, location, and loyalty ID, demonstrating how the system intelligently selects which identifiers should 'survive' while maintaining all original data."
            />
          }
          actions={
            <Button hasRightChevron href="/blog/golden-record" target="_blank">
              Learn more
            </Button>
          }
        />
        <Diptych
          size="lg"
          direction="right"
          chip={{ text: "Data warehouse writeback" }}
          titleAs="h2"
          title="Store your identity graph in your own warehouse"
          description="Keep your identity graphs and unified records in your data warehouse. Use your customer data and unique Hightouch IDs however you see fit. Hightouch never stores your data or limits how you put it to work."
          media={
            <FillImage
              src={bodyFeatureImage2}
              alt="An illustration showing a data table with four unique and complete identity records, with an outgoing line to represent that the data is coming from your data warehouse to Hightouch."
            />
          }
          actions={
            <Button hasRightChevron href="/docs/identity-resolution/usage" target="_blank">
              Learn more
            </Button>
          }
        />
      </Flex>
    </Section>
  );
}
